export function setScrollY(selector: string, overflowValue: 'auto' | 'hidden') {
  const element = document.querySelector<HTMLElement>(selector);

  if (!element) return;

  element.style.overflowY = overflowValue;
}
